import React from 'react';
import Typo from 'components/shared/Typo';
import RebootGA1DeviceConfirmDialog from './RebootGA1DeviceDialog';

function RebootGA1DeviceBundleDialog(props) {
  return (
    <RebootGA1DeviceConfirmDialog
      title={
        <Typo as="h3" variant="heading5">
          Reboot the devices?
        </Typo>
      }
      {...props}
    />
  );
}

export default RebootGA1DeviceBundleDialog;
